export enum ConstantKeysWidgets {
  HISTOGRAM = "histogram",
  ANALYTICS = "analytics",
  DONUT = "donut",
  TEXTAREA = "textarea",
  TEXT = "text",
  TABLE = "table",
  ACV = "acv",
}
